<template>
    <div class="relative">
        <UserPageMenu :current="currentRouteName"></UserPageMenu>

        <router-view :key="currentRouteName" @trimEdited="trimEdited"></router-view>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import UserPageMenu from "./UserPageMenu";

    export default {
        name: "UserPage",

        components: {
            UserPageMenu,
        },

        computed: {
            ...mapState('users', [
                'currentUserId',
            ]),

            currentRouteName() {
                return this.$route.name;
            },

        },

        methods: {
            ...mapActions('users', [
                'getCreatedTrims',
            ]),

            trimEdited() {
                this.getCreatedTrims(this.currentUserId);
            },

        },

    }
</script>

<style scoped>

</style>